// phonics_data_lt16.js
// Letter Teams L16 - L16 Digraphs qu, ck
// 路由：/phonics/lt16

const MEDIA_BASE = '/media/phonics/lt16';
const V = 'v1';

export const letterDataLt16 = {
  id: 'lt16',
  letter: 'L16',
  title: 'L16 Digraphs qu, ck',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1) → part1.mp4
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3) → part3.mp4
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）→ review.png
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P7/P8/P9: 三段故事（只有英文台词，无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals see the queen.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "She looks at the clock.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "It's time to see my duck.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Oh no!", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Where is my duck?", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "Who can help me find it?", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "We can!", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "The pals go to the pond.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Is the duck under the quilt?", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "No. Red is under the quilt.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Queen, is this your duck?", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "That is not my duck.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "That is a quail.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Quack! Quack!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Look by the rocks!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Oh. I see the duck.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Quick, grab it!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "My duck!", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Stay with me now.", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
      ],
    },
  ],
};
